module.exports = __webpack_public_path__ + "static/img/wanghe.84d8319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/wanghe.jpg
// module id = vD7H
// module chunks = 1